import {MultiSelect} from "./multiSelect.js";

export class AbsentHomeworkSelect extends MultiSelect {
    
    constructor(settings, classRegisterData) {
        settings.addData = true;
        //settings.listTitle = "Schüler wählen",
        super(settings);
        //this.classRegisterData = classRegisterData;
    }
  
    renderItem(item) {

        /*
        let elSelected = HTMLElement.createFromHTML(
            '<div class="selected-item">'
            + '   <div class="name">' + this.set.itemTextValue(this.set.addItem ? item.data : item) + '</div>'
            + '   <div class="btn-delete"><div class="font-icon icon-cross"></div></div>'
            + '</div>'
         );
   
         elSelected.setData('item', item);
   
         return elSelected;
         */

        if (item.info === undefined) item.info = { value: 1 };
        if (item.info.value === undefined) item.info.value = 1;
 

        let elSelected = HTMLElement.createFromHTML(
            `<div class="absent-homework-select selected-item">
                <div class="left">${item.info.value === 0.5 ? '½' : '1'}</div>
                <div class="middle">
                    <div class="name">${this.set.itemTextValue(item.data)}</div>
                </div>
                <div class="btn-delete"><div class="font-icon icon-cross"></div></div>
            </div>`
         );
 
        elSelected.setData('item', item);

        elSelected.querySelector('.left').onclick = (event) => {
            event.stopPropagation();
            if (event.target.innerText === '1') {
                event.target.innerText = '½';
                item.info.value = 0.5;
            }
            else {
                event.target.innerText = '1';
                item.info.value = 1;
            }
            elSelected.setData('item', item);
        }


        /*
        elSelected.querySelector('.name').innerText = this.set.itemTextValue(item.data);
        elSelected.querySelector('.cnt-hours').innerText = item.info.cntHours;
        elSelected.querySelector('.note').innerText = (item.info.note ? ' (' + item.info.note + ')' : '');

        elSelected.querySelector('.justified').checked = !!item.info.justified;

        elSelected.querySelector('.justified').onclick = (event) => {
            event.stopPropagation();
            elSelected.getData('item').info.justified = event.target.checked;            
        }        

        elSelected.querySelector('.left').onclick = (event) => {
            event.stopPropagation();
        }

        elSelected.querySelector('.middle').onclick = (event) => {
            event.stopPropagation();

            let maxHours = Math.max(this.classRegisterData.hour.to - (this.classRegisterData.hour.from -1), this.classRegisterData.hourSpan);
            let item = elSelected.getData('item');

            new ModalEditAbsence(
                `Fehlstunden von ${item.data.lastName}, ${item.data.firstName}`,
                maxHours,
                item.info.cntHours,
                item.info.note ? item.info.note : '',
                (cntHours, note) => {
                    item.info.note = note;
                    item.info.cntHours = cntHours;
                    this.setupItem(elSelected, item);
                    this.set.onChange(this.getSelectedItems());
                }
            );
        }

        this.setupItem(elSelected, item);
        */
  
        return elSelected;

  
    }

    /*
    setupItem(element, item) {
        element.querySelector('.note').innerHTML = item.info.note && item.info.note.length ? ` (${item.info.note})` : '';
        element.querySelector('.cnt-hours').innerHTML = item.info.cntHours;

        //let maxHours = this.classRegisterData.hour.to - (this.classRegisterData.hour.from -1);
        element.querySelector('.cnt-hours').style.display = this.classRegisterData.hourSpan === item.info.cntHours ? 'none' : 'flex';

    }
    */


  }